import {
  Outlet, useOutletContext, useParams,
} from 'react-router-dom';
import { ModalProvider } from '@equifinance/shared';
import { AppScreenSizeAlert } from '../components/AppScreenSizeAlert';
import { AccountProvider } from '../contexts/account';
import { RoutingContextType } from '.';
import { ProgressStatusProvider } from '../contexts/progressStatus/ProgressStatusProvider';

export function ApplicationRoutes() {
  const outletValue: RoutingContextType = useOutletContext();

  const { id } = useParams() as { id: string };

  const contextValue: RoutingContextType = {
    ...outletValue,
  };

  return (
    <ProgressStatusProvider>
      <AccountProvider id={id}>
        <ModalProvider>
          <AppScreenSizeAlert />
        </ModalProvider>
        <Outlet context={contextValue} />
      </AccountProvider>
    </ProgressStatusProvider>
  );
}
